import React, { useEffect, useRef } from 'react'
import { ImageBackground, StyleSheet } from 'react-native'

import { B2, B5, SH3, SH4, Stack, XStack } from '@zet/design-system'
import { EXPERT, GENIUS } from '@zet/feature-loyalty/utils/Constants'
import { i18n } from '@zet/localization'
import { DEVICE_HEIGHT, DEVICE_WIDTH } from '@zet/utils/Constants'
import { LinearGradient } from 'expo-linear-gradient'
import { ScrollView } from 'react-native-gesture-handler'

import { useGetLoyaltyGifts } from '../../api/brands/hooks'
import CoinBenefit from '../../assets/svg/coinBenefit.svg'
import MoneyGradient from '../../assets/svg/moneyGradient.svg'
import { handleTierBenefit } from '../../utils'
import CardTag from './cardTag'

const TierCardList = ({ tier, tierData }: { tier: any; tierData: any }) => {
  const scrollViewRef = useRef<ScrollView>()
  const { data: loyaltyGifts } = useGetLoyaltyGifts()
  function handleScroll() {
    switch (tier?.cohort) {
      case EXPERT:
        return DEVICE_WIDTH * 0.8
      case GENIUS:
        return DEVICE_WIDTH * 2
      default:
        return DEVICE_WIDTH * 0.01
    }
  }
  useEffect(() => {
    if (scrollViewRef.current) {
      scrollViewRef.current.scrollTo({
        x: 0,
        y: handleScroll(),
        animated: true,
      })
    }
  }, [])
  return (
    <ScrollView
      horizontal
      showsHorizontalScrollIndicator={false}
      ref={scrollViewRef}
    >
      <XStack className="px-3 py-2">
        {handleTierBenefit(tierData, tier, loyaltyGifts)?.map((item, index) => (
          <Stack key={index}>
            {item?.showTag && <CardTag />}
            <Stack
              className="mr-3 flex-1 overflow-hidden rounded-lg"
              style={styles.cardHeight}
            >
              <LinearGradient
                colors={['#0D101C', '#343A46', '#0D101C']}
                start={[0.1, 0]}
                end={[0.8, 0]}
                className="flex-1 border"
              >
                <Stack className="mb-5" style={styles?.cardHeaderHeight}>
                  <ImageBackground
                    source={require('../../assets/images/Background.png')}
                    resizeMode="cover"
                    className="flex-1"
                    imageStyle={styles.bgImageOpacity}
                  >
                    {item?.titleIcon}
                    <SH3 className="text-grays-40 mx-3 mb-4 text-center">
                      {item?.titleText}
                    </SH3>
                  </ImageBackground>
                  <XStack className="mx-4 -mt-2 items-center">
                    <Stack className="border-grays-50 flex-1 border-t"></Stack>
                    <SH4 className="text-grays-40 mx-3">
                      {i18n.t('brandDetails.benefits')}
                    </SH4>
                    <Stack className="border-grays-50 flex-1 border-t"></Stack>
                  </XStack>
                </Stack>

                <Stack className="px-3">
                  <XStack className="mb-2 items-center">
                    <MoneyGradient />
                    <B2 className="text-neutral-white100 ml-2">
                      {i18n.t('brandDetails.higherEarnings', {
                        percentage: item?.extraPayoutPercentage,
                      })}
                    </B2>
                  </XStack>
                  {item?.giftItem?.icon && (
                    <XStack className="mb-2 items-center">
                      {item?.giftItem?.icon}
                      <B2 className="text-neutral-white100 ml-2">
                        {i18n.t(`${item?.giftItem?.text}`)}
                      </B2>
                    </XStack>
                  )}
                  <XStack className="mb-3 items-center">
                    <CoinBenefit />
                    <B2 className="text-neutral-white100 ml-2">
                      {i18n.t('brandDetails.uptoCoins', {
                        coins: item?.coins,
                      })}
                    </B2>
                  </XStack>
                </Stack>
                <B5 className="text-grays-40 mx-3">
                  {i18n.t('brandDetails.termsAndCondition')}
                </B5>
              </LinearGradient>
            </Stack>
          </Stack>
        ))}
      </XStack>
    </ScrollView>
  )
}

export { TierCardList }
const styles = StyleSheet.create({
  cardHeight: { height: DEVICE_HEIGHT * 0.38, width: DEVICE_WIDTH * 0.8 },
  cardHeaderHeight: { height: '45%' },
  bgImageOpacity: { opacity: 0.5 },
})
